export enum ContentMode {
  Sessions,
  Downloads,
}
